import Layout from '../components/layout'
import PlaceSection from '../components/placeSection'
import ContactForm from '../components/form/contactForm'
import { useMediaQuery } from 'react-responsive';

export default function ContactPage() {
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' });
  return (
    <>
    <Layout>
    <section className="bpo_section">
      <div className="container">
        <div className="row">
          <div className="w_full">
            <h1 className="page_title textCenter">Contact us</h1>
          </div>          
        </div>
        <div className="row mb5">
          <div className={isMobile ? "w_12" : "w_8 mx-auto"}>
              <ContactForm />
          </div>
        </div>
      </div>
    </section>
    <PlaceSection notitle bgwhite />
    </Layout>
  </>
  )
}